import { useEffect, useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const SR = typeof window !== "undefined" ? window.SpeechRecognition || window.webkitSpeechRecognition : null;

export function MicButton({ onText, lang = "en-IN", testid = "mic-btn", className }) {
  const [on, setOn] = useState(false);
  const ref = useRef(null);
  useEffect(() => () => { ref.current?.abort(); }, []);
  const start = () => {
    if (!SR) { toast.error("Voice input works in Chrome on Android or desktop. Please type instead."); return; }
    const r = new SR();
    r.lang = lang;
    r.interimResults = false;
    r.onresult = (e) => onText([...e.results].map((x) => x[0].transcript).join(" "));
    r.onend = () => setOn(false);
    r.onerror = () => setOn(false);
    ref.current = r;
    r.start();
    setOn(true);
  };
  return (
    <Button type="button" size="icon" variant={on ? "default" : "outline"} onClick={on ? () => ref.current?.stop() : start}
      className={cn(on && "bg-red-600 hover:bg-red-700 text-white animate-pulse", className)} title={on ? "Stop" : "Speak"} data-testid={testid}>
      {on ? <MicOff className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
    </Button>
  );
}
